var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7333 7.83339L11.7833 15.7833C10.9916 16.575 8.64156 16.9417 8.11656 16.4167C7.59156 15.8917 7.94989 13.5417 8.74156 12.75L16.6999 4.79169C16.8962 4.57758 17.1338 4.40546 17.3984 4.28571C17.663 4.16596 17.9492 4.10104 18.2396 4.09493C18.5299 4.08882 18.8186 4.1416 19.088 4.25011C19.3574 4.35862 19.6021 4.52062 19.8072 4.72629C20.0123 4.93195 20.1736 5.17704 20.2813 5.44675C20.3891 5.71648 20.4412 6.00523 20.4343 6.2956C20.4273 6.58598 20.3616 6.87197 20.2412 7.13626C20.1207 7.40055 19.9479 7.63771 19.7333 7.83339Z",
    stroke: "#0F314D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 5.83334H7.00008C6.11602 5.83334 5.26823 6.18453 4.64311 6.80965C4.01799 7.43478 3.66675 8.28262 3.66675 9.16668V17.5C3.66675 18.3841 4.01799 19.2319 4.64311 19.857C5.26823 20.4822 6.11602 20.8333 7.00008 20.8333H16.1667C18.0084 20.8333 18.6667 19.3333 18.6667 17.5V13.3333",
    stroke: "#0F314D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/editPen.ec3ecfddfadc639a103ca7f95eca8fec.svg";
export { ForwardRef as ReactComponent };